import { push } from "connected-react-router";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { 
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION,
  ROUTE_PATH
} from "../../../app/constants";
import { Button } from "../../../components/RegularComponents";
import { currentAgentApplicationSelector } from "../../../redux/selector/collectorApplicationSelector";
import { setCurrentAgentMortgageProperty } from "../../../redux/slice/additionalApplicationsSlice";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import TopNavigationBar from "../../TopNavigationBar";

const MORTGAGE_APPLICATION_PROPERTY = "hasRequiredEducationQualification";

export const AssociateBrokerHasAssociateEducation = (props) => {
  const dispatch = useDispatch();

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW;
  const isAssociateBroker = (licencingSubType === LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION)

  //const [applicationSaveError, setApplicationSaveError] = useState(false);

  const handleNext = (hasCompletedMortgageBrokerEducation) => () => {
    dispatch(
      setCurrentAgentMortgageProperty({
        key: MORTGAGE_APPLICATION_PROPERTY,
        value: hasCompletedMortgageBrokerEducation,
      })
    );

    dispatch(
      setCurrentAgentMortgageProperty({
        key: 'hasRequiredEducationCertificate',
        value: true,
      })
    );

    dispatch(saveBusinessLicenceApplicationData(
      applicationType, applicationMode))
      .then(data => {
        const nextPath = hasCompletedMortgageBrokerEducation
            ? ROUTE_PATH.MRA_ASSOCIATE_UPLOAD_CERTIFICATE_COMPLETION
            : ROUTE_PATH.MRA_ASSOCIATE_NOT_HAS_COURSE;
          dispatch(push(`${ROUTE_PATH.MRA_APP}${nextPath}`));
      })
      .catch(err => {
        //setApplicationSaveError(true)
      })
  };

  return (
    <div className="container">
      <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>
            {`Has the applicant completed the Nova Scotia ${isAssociateBroker ? "Associate" : ""} Mortgage Broker Course?`}
          </h1>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <p>
            {`The applicant must complete the Nova Scotia ${isAssociateBroker ? "Associate" : ""} Mortgage Broker Course before they can apply for ${isAssociateBroker ? "an Associate" : "a"} Mortgage Broker licence.`}
          </p>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2">
          <Button
            className="ns-btn-yes-no"
            buttonType="regular_primary"
            onClick={handleNext(true)}
            text="Yes"
          />
        </div>

        <div className="col-lg-2">
            <Button
              className="ns-btn-yes-no"
              buttonType="regular_primary"
              onClick={handleNext(false)}
              value={false}
              text="No"
            />
          </div>
      </div>
    </div>
  );
};
